export const APP_BAR_HEIGHT = 56
export const CHAT_LIST_APP_BAR_HEIGHT = 56
export const APP_BAR_HEIGHT_CSS_VAR = 'var(--view-app-bar-height)'
